function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.172 9.924l1.84-7.166h.966l-.108 1.847L21.902 12H20.9l.273-2.076zm-1.377-7.166l1.491 7.11L21.42 12h-1.067l-2.139-9.242h1.58zm6.271 7.09l1.473-7.09h1.587L26.986 12H25.92l.146-2.152zm-1.714-7.09l1.822 7.185.267 2.057h-1.003l-1.936-7.395-.102-1.847h.952zm12.004 7.979V12h-4.907v-1.263h4.907zM31.9 2.757V12h-1.594V2.758H31.9zm3.815 3.86v1.244h-4.266V6.617h4.266zm.609-3.86v1.27h-4.875v-1.27h4.875zm4.799 5.066h-2.355l-.013-1.161h2.057c.347 0 .64-.051.882-.153a1.22 1.22 0 0 0 .559-.45c.127-.2.19-.438.19-.718 0-.309-.06-.56-.178-.755a1.017 1.017 0 0 0-.546-.425c-.24-.09-.55-.134-.926-.134H39.25V12h-1.593V2.758h3.136c.508 0 .96.048 1.358.146.402.097.743.25 1.022.457.284.203.497.461.641.774.148.313.222.686.222 1.117 0 .381-.09.73-.273 1.048-.182.313-.45.569-.806.768-.355.199-.797.317-1.326.355l-.508.4zM41.053 12h-2.787l.718-1.263h2.069c.36 0 .66-.06.901-.178.242-.123.421-.29.54-.501.123-.216.184-.468.184-.756 0-.3-.053-.56-.159-.78a1.093 1.093 0 0 0-.501-.515c-.229-.122-.527-.184-.895-.184h-1.79l.012-1.161h2.33l.362.438c.508.017.925.129 1.25.336.33.207.576.476.737.806.16.33.24.686.24 1.067 0 .588-.128 1.08-.386 1.479-.254.397-.62.7-1.099.907-.478.203-1.053.305-1.726.305z",
  fill: "#1063CD"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  clipPath: "url(#impersonate_svg__clip0_19725_38982)",
  stroke: "#1063CD",
  strokeLinecap: "round"
}, React.createElement("path", {
  d: "M.583 12.567v-.583a4.083 4.083 0 0 1 8.167 0v.583"
}), React.createElement("path", {
  d: "M7.583 9.067a2.917 2.917 0 0 1 5.834 0v.292"
}), React.createElement("path", {
  d: "M4.667 7.9a2.333 2.333 0 1 0 0-4.666 2.333 2.333 0 0 0 0 4.666zM10.5 6.15a1.75 1.75 0 1 0 0-3.5 1.75 1.75 0 0 0 0 3.5z",
  strokeLinejoin: "round"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "impersonate_svg__clip0_19725_38982"
}, React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .9)",
  d: "M0 0h14v14H0z"
})));

const SvgImpersonate = props => React.createElement("svg", _extends({
  width: 46,
  height: 16,
  fill: "none"
}, props), _ref, _ref2, _ref3);

export default SvgImpersonate;